import { useEffect } from 'react';
import { appParameters } from '../../config/appParameters';

export default function useUpdateMetadata() {
  const path = 'public';

  useEffect(() => {
    // Dynamic change of icons, meta and title based on app rendered
    const favicon = document.querySelector("link[rel*='icon']");
    const appleIcon = document.querySelector("link[rel*='apple-touch-icon']");
    const maskIcon = document.querySelector("link[rel*='mask-icon']");
    const description = document.querySelector("meta[name='description']");

    if (favicon) favicon.setAttribute('href', '/favicon.ico');
    if (appleIcon) appleIcon.setAttribute('href', '/apple-touch-icon-180x180.png');
    if (maskIcon) maskIcon.setAttribute('href', '/maskable-icon-512x512.png');
    if (description) description.setAttribute('name', `${appParameters.APP_NAME}`);
    document.title = appParameters.APP_NAME;
  }, [path]);
}
